var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{ref:"iframe",staticStyle:{"border":"none","height":"100%","width":"100%"},attrs:{"title":_vm.title || 'Video calling component',"src":_vm.iframeSrc,"allow":"autoplay; camera; microphone; fullscreen; speaker; display-capture; media-capture"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }